var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRetry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 196.32,
    height: 226.994,
    viewBox: "0 0 196.32 226.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "retry",
    transform: "translate(-114.21 -14.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4455",
    "data-name": "Path 4455",
    d: "M310.53,186.58a98.16,98.16,0,1,1-98.16-98.16v24.539a73.619,73.619,0,1,0,73.619,73.619Z",
    transform: "translate(0 -43.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4456",
    "data-name": "Path 4456",
    d: "M347.05,88.422h25.767v24.541H347.05Z",
    transform: "translate(-135.908 -43.009)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4457",
    "data-name": "Path 4457",
    d: "M341.459,14.738l43.383,43.383L367.489,75.474,324.106,32.091Z",
    transform: "translate(-122.516)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4458",
    "data-name": "Path 4458",
    d: "M367.483,77.262l17.353,17.353L341.453,138,324.1,120.645Z",
    transform: "translate(-122.512 -36.495)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetry);
export default __webpack_public_path__ + "static/media/retry.30841958ba73b89fe7a66fd4c7fd5b4a.svg";
export { ForwardRef as ReactComponent };